module.exports = __webpack_public_path__ + "static/the-four-agreements-c70c93239864cdd4516f585c9480e279.jpg";